export default "__VITE_ASSET__yzF4kTZi__"